<template>
    <div class="singBox" v-if="isshow">
        <div class="singIndex" v-if="!iserror&&status=='1'">
            <div class="indexImg">
                <img :src="dataInfo.coverlogourl" alt="">
            </div>
            <div class="indexMain">
                <p>签到名称：{{dataInfo.subject}}</p>
                <p>签到时间：{{dataInfo.signtime}}</p>
            </div>
            <div class="indexBtn" @click="sureEvent">确认</div>
        </div>
        <!--出错提示-->
        <div class="singIndex errorBox" v-else>
            <img :src="error" class="errorImg" alt="">
            <p>{{mesg}}</p>
        </div>
    </div>
</template>

<script>
    import {getIndex} from 'api/signApi'
    import {mapActions} from 'vuex'
    export default {
        name: "Index",
        data(){
            return{
                singImg:require('@/common/images/singInImg/singImg.png'),
                error:require('@/common/images/singInImg/error.png'),
                dataInfo:{},
                status:'', // 状态
                iserror:false,
                isshow:false,
                mesg:'', // 错误消息
                EventId:this.$route.query.eid?this.$route.query.eid:''
            }
        },
        mounted(){
          window.sessionStorage.setItem('eid', JSON.stringify(this.EventId))
          this.setEid(this.EventId)
          this._getInfo()
          document.title="签到360-简单方便的签到工具-鲸融网"
        },
        methods:{
            // 获取首页信息
            _getInfo(){
                this.setLoading(true);
                getIndex({
                    data: {
                        timestamp: this.$route.query.timestamp?this.$route.query.timestamp:'',
                        sign: this.$route.query.sign?this.$route.query.sign:'',
                    },
                    success: data => {
                        this.setLoading(false);
                        this.dataInfo=data.data
                        this.status=data.data.status
                        this.isshow=true
                        this.mesg=data.data.mesg
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.iserror=true
                        this.isshow=true
                    },
                })
            },
            // 确认
            sureEvent(){
                this.$router.push({name:'NameMgt'})
            },
            ...mapActions([
                'setLoading','setEid'
            ])
        }
    }
</script>

<style scoped lang="scss">
    .singIndex{
        width:555px;
        height:555px;
        box-shadow:0 1px 12px 0 rgba(160,160,160,0.5);
        border-radius:8px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        .indexImg{
            width: 555px;
            height: 287px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .indexMain{
            padding: 0 40px;
            margin-top: 25px;
            font-size: 18px;
            color: #333;
            p{
                line-height: 25px;
                margin-top: 15px;
            }
        }
        .indexBtn{
            width:404px;
            height:63px;
            line-height: 63px;
            font-size:20px;
            color: #fff;
            text-align: center;
            background:rgba(42,126,251,1);
            border-radius:8px;
            margin: 75px auto 0;
            cursor: pointer;
        }
    }
    .errorBox{
        background: #fff;
        text-align: center;
        .errorImg{
            width: 400px;
            height: 370px;
            margin: 57px auto 0;
        }
        p{
            font-size: 28px;
            color: #A2ADC2;
            padding-top: 30px;
        }
    }
</style>